<div class="container">
    <div class="loading-box"></div>
    <div class="loading-box"></div>
    <div class="loading-box"></div>
    <div class="loading-box"></div>
    <div class="loading-box"></div>
</div>